/**
 * Parse a badge/NFC tap payload into the two fields
 * `POST /shopfloor-kiosk/sessions` actually requires
 * (`operator_id: number`, `credential: string`) — see
 * StartOperatorSessionRequest in api-schema.generated.ts.
 *
 * Tharstern's `login_operator` needs both an operator id and a PIN-shaped
 * credential; nothing in the shipped backend decodes a badge payload into
 * those two values (no server-side badge parser exists, unlike job-bag
 * scans' `_scan_code.py`). Until the real badge/NFC print/encoding format
 * is confirmed with whoever provisions the physical badges, this assumes
 * the same provisional convention already used for job-bag codes elsewhere
 * in this feature: `"{operator_id}:{credential}"`. Revisit this parser
 * (not the rest of the login flow) if the real format differs — flagged
 * as an open question alongside the job-bag barcode encoding in
 * docs/features/shopfloor-barcode-scanning/99_outstanding_setup.md.
 */

export interface ParsedBadgeTap {
  operatorId: number;
  credential: string;
}

export function parseBadgeTap(rawPayload: string): ParsedBadgeTap | null {
  const parts = rawPayload.trim().split(":");
  if (parts.length !== 2) return null;
  const operatorId = Number(parts[0]);
  const credential = parts[1];
  if (!Number.isInteger(operatorId) || operatorId <= 0 || !credential) {
    return null;
  }
  return { operatorId, credential };
}
